import { CustomFontStyle } from "@redotech/redo-content-builder-common/brand-kit";
import { memo } from "react";
import { useFontLoader } from "./use-font-loader";

export const FontStyleLoader = memo(function FontStyleLoader({
  fontFamily,
  style,
}: {
  fontFamily: string;
  style: CustomFontStyle;
}) {
  useFontLoader({
    fontFileUrl: style.fontFileUrl || "",
    fontFamily,
    fontWeight: style.weight || "normal",
    fontStyle: style.italic ? "italic" : "normal",
    fontId: style._id,
    persistOnUnmount: true,
  });
  return null;
});
